var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_ReasonOfCargoDetention"),
            width: "300px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", [
              _c(
                "div",
                { staticClass: "form-row", staticStyle: { display: "flex" } },
                [
                  _c("div", { staticStyle: { margin: "auto", width: "25%" } }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_ReasonOfCargoDetentionP"))
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    { staticStyle: { width: "75%" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { no: "remark", type: "textarea", rows: 5 },
                        model: {
                          value: _vm.remark,
                          callback: function($$v) {
                            _vm.remark = $$v
                          },
                          expression: "remark"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "spacing" }),
            _c(
              "div",
              { staticClass: "triggers", attrs: { align: "right" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "confirm", type: "primary" },
                    on: { click: _vm.selectedHandler }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.confirm")) + " ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "close", type: "primary" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.close")) + " ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }